import React from 'react';
import { Divider, Row, Space } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useAccount } from 'ShorePay/hooks/account';
import styled from 'styled-components';
import { Link } from 'react-router';
import AccountOverviewStats from './AccountOverviewStats';
import TransactionsTable from './TransactionsTable';
import RevenueOverviewChart from './RevenueOverviewChart';

const Title = styled.h3`
  margin: 0;
  padding: 20px 24px;
`;

const AccountOverview = () => {
  const accQuery = useAccount();

  if (
    accQuery.isSuccess &&
    (accQuery.data.stripe_account_status === 'Complete' ||
      accQuery.data.stripe_account_status === 'Enabled')
  ) {
    const {
      balance,
      last_payout,
      stripe_account_data: { default_currency: currency },
    } = accQuery.data;
    return (
      <>
        <Title>
          <FormattedMessage defaultMessage="Account Overview" />
        </Title>
        <Divider css="margin: 0" />
        <Space
          size="large"
          direction="vertical"
          css={`
            width: 100%;
            padding: 24px;
          `}
        >
          <AccountOverviewStats
            balance={balance}
            last_payout={last_payout}
            currency={currency}
          />
          <Row>
            <RevenueOverviewChart currency={currency} />
          </Row>
          <div>
            <Row justify="space-between">
              <h3>
                <FormattedMessage defaultMessage="Last Transactions" />
              </h3>
              <Link to="/shorepay/reports?_=1" css="padding-right: 10px">
                <FormattedMessage defaultMessage="All transactions" />
              </Link>
            </Row>
            <TransactionsTable
              filterLocal
              pagination={false}
              dataSource={accQuery.data.last_transactions ?? []}
              scroll={{ y: 500 }}
              css={`
                .ant-table {
                  border: solid 1px rgba(0, 0, 0, 0.15);
                  border-radius: 4px;
                  box-sizing: border-box;
                }
              `}
            />
          </div>
        </Space>
      </>
    );
  }

  return null;
};

export default AccountOverview;
